ALLOWED_CONTROLLER = 'info'
ALLOWED_ACTIONS = ['contact', 'submit_contact']

addAriaHiddenToAnonymousIframes = ->
  observer = new MutationObserver (mutations) ->
    mutations.forEach (mutation) ->
      $(mutation.addedNodes).each (i, node) ->
        return unless node.nodeName is 'IFRAME'
        $node = $(node)
        if !$node.attr('src')? and !$node.attr('title')?
          unless $node.attr('aria-hidden')?
            $node.attr('aria-hidden', 'true')

  observer.observe document.body,
    childList: true
    subtree: true

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  addAriaHiddenToAnonymousIframes()

  $('select').on 'change', ->
    if $('select').val() == 'My card is not working' || $('select').val() == 'Equipment is broken or not working'
      $('*[data-selector="card_number_paragraph"]').show()
    else
      $('*[data-selector="card_number_paragraph"]').hide()


$(document).ready(ready)
$(document).on('turbo:load', ready)
